var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 25,
    viewBox: "0 0 122 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4347 20.559L12.4626 9.39693L9.44321 20.559H5.23674L0.00512695 4.41577H4.34986L7.4826 16.2927L10.5468 4.41577H14.5253L17.6581 16.2927L20.7447 4.41577H24.9064L19.6249 20.559H15.4347Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4119 7.64442V10.8504H38.0488V14.0791H30.4119V17.3366H39.1238V20.5653H26.3412V4.41577H38.8721V7.64442H30.4119Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6151 17.1231V20.559H41.7533V4.41577H45.824V17.1231H52.6151Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4201 17.1231V20.559H54.5583V4.41577H58.629V17.1231H65.4201Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M119.779 0H70.4101C69.1835 0 68.1891 1.00286 68.1891 2.23995V22.76C68.1891 23.9971 69.1835 25 70.4101 25H119.779C121.006 25 122 23.9971 122 22.76V2.23995C122 1.00286 121.006 0 119.779 0Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3977 4.41577C84.9888 4.41577 87.2746 5.98361 87.2746 8.45095C87.2746 10.1582 86.2233 11.5188 84.5342 12.0025C86.5459 12.3957 87.8264 13.9861 87.8264 16.0854C87.8264 18.8291 85.4485 20.559 81.6755 20.559H73.8281V4.41577H81.3977ZM77.8763 10.8731H81.1698C82.3581 10.8731 83.1129 10.2273 83.1129 9.18964C83.1129 8.15195 82.3581 7.55647 81.1698 7.55647H77.8763V10.8731ZM77.8763 17.3994H81.1698C82.6795 17.3994 83.6162 16.7311 83.6162 15.5778C83.6162 14.4937 82.6795 13.8253 81.1698 13.8253H77.8763V17.3994Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2488 7.64442V10.8504H101.887V14.0791H94.2488V17.3366H102.961V20.5653H90.1781V4.41577H102.709V7.64442H94.2488Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M112.999 7.71355V20.559H108.93V7.71355H104.15V4.39697H117.825V7.71355H112.999Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default ForwardRef;